import React, { useEffect } from "react";
import DepositForm from "../../components/Forms/DepositForm";
import { usePageContext } from "../../utils/PageContext";

export default function DepositPage() {
  const { changeArticleType } = usePageContext();

  useEffect(() => {
    changeArticleType("INDIVIDUAL");
  }, []);

  return <DepositForm />;
}
